export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  // Match nested routes (e.g. /lists/SMS/1 → /lists/SMS), but avoid prefix
  // collisions (e.g. /lists/SMSAnalytics must not match /lists/SMS).
  return current.startsWith(`${url}/`)
}
